import dashboard from 'partner/Dashboard/reducer'
import order from 'partner/Order/reducer'
import accounts from 'partner/UserManagement/reducer'

export default {
  dashboard,
  order,
  accounts,
}
